<template>
  <div class="carousel_wrap">
    <el-carousel arrow="never" class="hidden-xs-only" height="37vw" loop>
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item"/>
        <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <h1>{{ item.line2 }}</h1>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel arrow="never" class="hidden-sm-and-up" height="50vw" loop>
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item"/>
        <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <h1>{{ item.line2 }}</h1>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          // src: require('@/assets/img/aimes1.png'),
          src: require('@/assets/img/bg-1111.png'),
          line1: '以创新为动力，以质量为保障',
          line2: '为客户提供优质的产品和服务',
        },
        {
          // src: require('@/assets/img/bg_mes.png'),
          src: require('@/assets/img/bg-22222.png'),
          line1: '全面推进数字建设化改革',
          line2: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.carousel_wrap {
  position: relative;

  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .tips_font {
    position: absolute;
    top: 100px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
</style>
